var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelojDePared1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58891 0 0 3.58872 0 8C0 12.4113 3.58891 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58872 12.4111 0 8 0ZM8 14.8321C4.23281 14.8321 1.16788 11.7672 1.16788 8C1.16788 4.23281 4.23281 1.16788 8 1.16788C11.7672 1.16788 14.8321 4.23278 14.8321 7.99981C14.8321 11.7672 11.7672 14.8321 8 14.8321Z",
    fill: "#2D3035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.725 8.00001H8.19461V4.49635C8.19461 4.17382 7.9332 3.91241 7.61067 3.91241C7.28814 3.91241 7.02673 4.17382 7.02673 4.49635V8.58395C7.02673 8.90648 7.28814 9.16788 7.61067 9.16788H10.725C11.0475 9.16788 11.309 8.90648 11.309 8.58395C11.309 8.26142 11.0475 8.00001 10.725 8.00001Z",
    fill: "#2D3035"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelojDePared1);
export default __webpack_public_path__ + "static/media/reloj-de-pared 1.95d442713650d324d071cf382c7a3096.svg";
export { ForwardRef as ReactComponent };